module.exports = __webpack_public_path__ + "media/images/prepaid-1-751d1d2ec8c54ae908e2d71d367d47a8.png";